import {Category} from "./types";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {collection, getDocs, orderBy, query} from "firebase/firestore";
import {db} from "../../firebase";
import {categoryConverter} from "../../firebase/converters";

export const fetchCategories = createAsyncThunk<
  Category[],
  void,
  {}
>('categories/fetchCategories', async () => {
  const q = query(
    collection(db, 'categories'),
    orderBy('order', 'asc')
  ).withConverter(categoryConverter);
  const snapshot = await getDocs(q);
  return snapshot.docs.map(d => d.data());
});